/* eslint-disable @typescript-eslint/dot-notation */
import { InternalAxiosRequestConfig } from 'axios';

import { HttpClient } from '../HttpClient';
import { IHttpClientConfig } from '../HttpClient.interface';

import { getAccessToken } from '@/utils/auth/token.utils';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { NotValidAccessTokenException } from '@/exсeptions/NotValidAccessTokenExceptions';
import { NotValidSubscriptionIdException } from '@/exсeptions/NotValidSubscriptionIdExceptions';

export const varBillingAbortController = new AbortController();

const clientConfig: IHttpClientConfig = {
  baseURL: process.env.REST_SERVER_ENDPOINT_VARBILLING,
  signal: varBillingAbortController.signal,
};

export const varBillingFunctionsClient = new HttpClient(clientConfig);

const requestInterceptor = async (config: InternalAxiosRequestConfig) => {
  if (!config?.headers) throw new Error('Can\'t get request headers');

  const accessToken = await getAccessToken();
  const subscriptionId = await getSubscriptionId();

  if (!accessToken) throw new NotValidAccessTokenException();
  if (!subscriptionId) throw new NotValidSubscriptionIdException();

  config.headers['subscriptionid'] = subscriptionId;
  config.headers['SubscriptionId'] = subscriptionId;
  config.headers['Authorization'] = `Bearer ${accessToken}`;

  return config;
};

varBillingFunctionsClient.addRequestInterceptor(requestInterceptor);
